import { ReportingControllerBaseConfig } from '../../../base';
import { SnippetInputController } from './snippetInputInterface';
import { SnippetInputControllerProps, SnippetInputViewProps } from './snippetInputProps';

export function createSnippetInputController(
    config: ReportingControllerBaseConfig
): SnippetInputController {
    function getViewProps(
        props: SnippetInputControllerProps
    ): SnippetInputViewProps['view'] {
        if (props.value === null && !props.disclosure.isOpen) {
            return {
                kind: 'empty',
                label: 'Snippet',
                button: {
                    onClick: props.disclosure.onOpen,
                },
            };
        }
        if (props.value && !props.disclosure.isOpen) {
            return {
                kind: 'label',
                snippet: {
                    id: props.value.id,
                },
                onOpen: props.disclosure.onOpen,
            };
        }
        if (props.value !== null && props.disclosure.isOpen) {
            return {
                kind: 'edit',
                snippet: {
                    id: props.value.id,
                },
                onSave(snippet) {
                    return props.onUpdate(snippet);
                },
                onClose: props.disclosure.onClose,
            };
        }
        return {
            kind: 'new',
            onSave(snippet) {
                return props.onCreate(snippet);
            },
            onClose: props.disclosure.onClose,
        };
    }
    return {
        useProps(context, item, props): SnippetInputViewProps {
            return {
                root: {
                    element: {
                        onKeyUp(event) {
                            if (event.key === 'Escape' && props.closeOnEscape) {
                                props.disclosure.onClose();
                                event.preventDefault();
                                event.stopPropagation();
                            }
                        },
                    },
                },
                view: getViewProps(props),
            };
        },
    };
}
